import * as Sentry from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider } from '@tanstack/react-router'
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary'
import { Toaster } from 'sonner'

import { ZMPProvider } from '@/common/provider/zmp.provider'
import { queryClient } from '@/common/query/query-client'
import { storefrontConfig } from '@/common/storefront/storefront.config'
import { router } from '@/router'

function Fallback({ error }: FallbackProps) {
  const message = error instanceof Error ? error.message : String(error)

  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre style={{ color: 'red' }}>{message}</pre>
    </div>
  )
}

const MyApp = () => (
  <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary FallbackComponent={Fallback}>
        <ZMPProvider>
          <RouterProvider
            router={router}
            context={{ queryClient, storefront: storefrontConfig }}
          />
          <Toaster richColors position="top-center" />
        </ZMPProvider>
        <ReactQueryDevtools initialIsOpen />
      </ErrorBoundary>
    </QueryClientProvider>
  </Sentry.ErrorBoundary>
)

const MyAppProfiler = Sentry.withProfiler(MyApp)
MyAppProfiler.displayName = 'MyApp'

export default MyAppProfiler
